import { equalTo, get, limitToFirst, orderByChild, query, ref } from "firebase/database";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { realTimeDB } from "../firebase";
import { AuthContext } from "../AuthContext";
import { sanitizeText } from "../newComponents/GeneralClasses";
import MyUploadedMessagesContent from "./MyUploadedMessagesContent";
import { HbrCancel } from "../newComponents/Mycustomsvgicons";
import EditMessage from "./EditMessages";

const MyUploadedMessages = ({handleCancel}) => {
    const [myUploads, setMyUploads] = useState([]);
    const [showMessageEditor, setShowMessageEditor] = useState(false);
    const [messageTitle, setMessageTitle] = useState("");
    const [preacher, setPreacher] = useState("");
    const [audioUrl, setAudioUrl] = useState(null);
    const [description, setDescription] = useState("");
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [videoLink, setVideoLink] = useState("");
    const [messageGenre, setMessageGenre] = useState("");
    const [messageId, setMessageId] = useState("");
    const {user_email}= useContext(AuthContext);

    useEffect(()=>{
        async function fetchUploadedMessages() {
            const messagesRef = ref(realTimeDB,"hrmw_messages");
            const messagesQuery = query(messagesRef, limitToFirst(100), orderByChild("uploadBy"), equalTo(sanitizeText(user_email)));
            const getMessagesSnapshot = await get(messagesQuery);
            if (getMessagesSnapshot.exists()) {
                const messagesData = getMessagesSnapshot.val();
          
               const arrayOfMessages = Object.keys(messagesData).map((messageId)=>({
                ...messagesData[messageId]
                }))
                setMyUploads(arrayOfMessages);
            }
        }
        fetchUploadedMessages();
    },[user_email]);

    const memoizedMessages = useMemo(()=>myUploads,[myUploads]);

    const handleMessageDeleted = useCallback((messageDeletedId)=>{
        setMyUploads(prev => prev.filter(messageData => messageData.id !== messageDeletedId));
    },[]);

    const handleGetMessageInfoToEdit=(title, preacher, description, videoUrl, thumbnail, url, genre, messageId)=>{
        setMessageTitle(title);
        setPreacher(preacher);
        setVideoLink(videoUrl);
        setThumbnailFile(thumbnail);
        setMessageGenre(genre);
        setAudioUrl(url);
        setDescription(description);
        setMessageId(messageId);
        setShowMessageEditor(true);
    };


    return ( 
        <div className="my-uploaded-messages">
            <div className="my-uploaded-messages-overlay flex-column1" style={{position:"relative",width:"100%", height:"100%"}}>
                <div className="flex-spacebetween" style={{height:"10%", width:"100%"}}>
                    <h3 style={{color:"white", textAlign:"center", paddingTop:"10px"}}>My Uploads {memoizedMessages.length}</h3>
                    <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleCancel()}/>
                </div>

                <div className="my-upload-list">
                    {memoizedMessages && memoizedMessages.map(data => (
                    <MyUploadedMessagesContent 
                    key={data.id}
                    messageId={data.id}
                    title={data.title}
                    preacher={data.preacher}
                    description={data.description}
                    videoUrl={data.videoUrl}
                    thumbnail={data.thumbnail}
                    url={data.url}
                    genre={data.genre}
                    handleEditMessage={handleGetMessageInfoToEdit}
                    onMessageDeleted={handleMessageDeleted}
                    />
                    ))}
                </div>
            </div>

            {showMessageEditor && 
                <EditMessage 
                title={messageTitle}
                messagePreacher={preacher}
                description={description}
                videoUrl={videoLink}
                thumbnail={thumbnailFile}
                audioUrl={audioUrl}
                genre={messageGenre}
                messageId={messageId}
                handleCancel={()=>setShowMessageEditor(false)}
                />
            }
        </div>
     );
}
export default MyUploadedMessages;